export enum AppStatus {
    'None' = 0,
    'ViewSI',
    'ViewExp',
    'EditExp',
    'ValidateExp',
}
